export const getLoggedIn = state => state.auth.isLoggedIn;

export const getRegistered = state => state.auth.isRegistered;
